import axiosInstance from '../../functions/axiosInstance';
import server_config from '../../ServerConfiguration';

const computable_publishing_node_server_address = server_config["computable_publishing_node_server_address"];

export const fetchMediaLibrary = async () => {
    let response = { 'success': false };
    response = await axiosInstance({
        method: 'POST',
        url: computable_publishing_node_server_address,
        timeout: 5000,
        data: { "functionid": "retrievemedialibrary", "libraryfunction": "axios" },
    }).then(async (resp) => {
        return resp.data;
    }).catch(async (error) => { });
    if (response.success) {
        return new Promise(resolve =>
            resolve({ data: response.storedMediaLibrary })
        )
    }
}

export const updateMediaLibrary = async (newMediaLibrary) => {
    let response = { 'success': false };
    console.log("updateMediaLibrary")
    console.log(newMediaLibrary)
    response = await axiosInstance({
        method: 'POST',
        url: computable_publishing_node_server_address,
        timeout: 5000,
        data: { "functionid": "changemedialibrary", "newMediaLibrary": newMediaLibrary, "libraryfunction": "axios", "analyticsBypass": true }
    })
    .then(async (resp) => { return resp.data; })
    .catch(async (error) => {
        console.log("FAILURE of updateMediaLibrary")
        console.log(error);
    });
    if (response.success) {
        return new Promise(resolve => resolve({ data: response.success}))
    }

}
